import { Button, FileUploadTrigger } from "@wayflyer/flyui";
import type { UseUploadManagerReturn } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UPLOAD_STATEMENTS_SIZE_LIMIT_MB } from "../../../../components/constants";

import type { BankStatementUpload } from "../../hooks/use-bank-accounts-upload-manager";

import { MESSAGES } from "../message-definitions";

type AddStatementsButtonProps = {
  onFilesAdded: UseUploadManagerReturn<BankStatementUpload>["onFilesAdded"];
  fullWidth?: boolean;
  disabled?: boolean;
};

export const AddStatementsButton = ({ fullWidth, disabled, onFilesAdded }: AddStatementsButtonProps) => {
  const intl = useIntl();

  return (
    <FileUploadTrigger
      onFilesAdded={onFilesAdded}
      acceptedFileTypes={{ "text/csv": [".csv"], "application/pdf": [".pdf"] }}
      sizeLimitMB={UPLOAD_STATEMENTS_SIZE_LIMIT_MB}
      testId="banking-accounts-statements"
      disabled={disabled}
      trigger={({ open, disabled: triggerDisabled }) => (
        <Button variant="Tertiary" fullWidth={fullWidth} onClick={open} disabled={disabled || triggerDisabled}>
          {intl.formatMessage(MESSAGES.addStatementsManually)}
        </Button>
      )}
    />
  );
};
